import React from "react";
import "./Intro.css";
import map from "../../img/map_pak_intro.png";
import { Link } from "react-scroll";
const Intro = () => {
  return (
    <div className="Header-Section flex-container" id="intro-section">
      <div className="Headerr container">
        <div className="left-header">
          <div className="left-headerTxt">
            <span>TRUSTED CHARITY ORGANIZATION</span>
            <span>
              Education for Stability:<a href="_"> Empowering </a>Pakistan's Future Using Tech!
            </span>
            <span>
              <p>
                {" "}
                "Those who spend their wealth [in Allah's way] by night and by day, secretly and publicly - they will have their reward with their Lord. And no fear will there be concerning them, nor will they grieve." (2:274).{" "}
              </p>
            </span>
            <div className="left-header-btn">
              <button class="donate-now button-5">
                <Link spy={true} to="donate-section" smooth={true}>
                  Donate Now
                </Link>
              </button>
              <button class="need-a-help button-5">
                <Link spy={true} to="contact-section" smooth={true}>
                  Need Help
                </Link>
              </button>
            </div>
          </div>
        </div>

        <div className="right-header">
          <img src={map} alt="map-pak" fetchpriority="high"></img>
        </div>
      </div>
      <div className="intro-mmf">
        <div className="i-mmf mehfooz">MEHFOOZ</div>
        <div className="i-mmf mustaqbil">MUSTAQBIL</div>
        <div className="i-mmf foundation">FOUNDATION</div>
      </div>
    </div>
  );
};

export default Intro;
